import React, { Component } from 'react';
import Presenter from './presenter';
import Model from './model';
import View from './view';

export default class ClaimLanding extends Component {
  constructor(props) {
    super(props);
    const { config, onRegister, initialToken, language, languagePolicies } = props;
    this.presenter = new Presenter(
      new Model(this, {
        tokenValue: initialToken || '',
        errorToken: null,
        allowEmail: false,
        allowPhone: false,
        countryCode: null,
        showCountryCode: false,
        disableCountryPicker: false,
        nameValue: '',
        errorName: null,
        captureName: false,
        nameType: '',
        loading: false,
        primaryConsent: false,
        showPrimaryConsent: true,
        errorPrimaryConsent: null,
        marketingConsent: false,
        showMarketingConsent: false,
        marketingConsentTerms: '',
        selectedAdditional: null,
        captureAdditional: null,
        customInput: null,
        errorAdditional: null,
        showFacebook: false,
        showGoogle: false,
        showOutsideOauth: false,
        oauthOnly: false,
        advertiserName: '',
      }),
      config,
      onRegister,
      language,
      languagePolicies
    );
  }

  componentDidMount() {
    this.presenter.onAttach();
  }

  componentDidUpdate(prevProps) {
    const { initialToken } = this.props;
    if (initialToken !== prevProps.initialToken) {
      this.presenter.onInitialTokenChange(initialToken);
    }
  }

  render() {
    const { languagePolicies } = this.props;
    return <View {...this.state} presenter={this.presenter} languagePolicies={languagePolicies} />;
  }
}
